import { render, staticRenderFns } from "./RowsPerPageDropdown.vue?vue&type=template&id=1d61bdba&"
import script from "./RowsPerPageDropdown.vue?vue&type=script&lang=js&"
export * from "./RowsPerPageDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports